<template>
    <app-dialog
        :value="value"
        size="sm"
        append-to-body
        @input="$emit('input', $event)"
    >
        <template #header>
            <h3 class="text-lg font-semibold text-theme-base">
                ¿Restaurar esta versión?
            </h3>
        </template>

        <div v-if="version" class="flex flex-col gap-3 text-sm">
            <p class="text-theme-muted">
                Tu diseño actual se reemplaza por el del
                <strong class="text-theme-base">{{ formattedDate }}</strong
                >.
            </p>
            <p class="rounded-lg bg-theme-hover px-3 py-2 text-theme-muted">
                Antes de reemplazarlo guardamos una copia de tu diseño actual,
                así puedes volver.
            </p>
        </div>

        <template #footer>
            <div class="flex items-center gap-2">
                <app-button
                    class="flex-1"
                    color="success"
                    :loading="isSaving"
                    @click="$emit('confirm')"
                >
                    Restaurar
                </app-button>
                <button
                    type="button"
                    :disabled="isSaving"
                    class="rounded-lg border border-theme-border bg-theme-card px-3 py-2 text-sm font-medium text-theme-muted transition hover:bg-theme-hover disabled:opacity-50"
                    @click="$emit('input', false)"
                >
                    Cancelar
                </button>
            </div>
        </template>
    </app-dialog>
</template>

<script>
import { DateTime } from "luxon";

import AppButton from "@/components/utils/AppButton.vue";
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "CatalogRestoreConfirmModal",
    components: { AppButton, AppDialog },
    props: {
        value: { type: Boolean, default: false },
        version: { type: Object, default: null },
        isSaving: { type: Boolean, default: false }
    },
    computed: {
        formattedDate() {
            if (!this.version?.createdAt) return "";
            return DateTime.fromISO(this.version.createdAt)
                .setLocale("es")
                .toFormat("d 'de' LLLL yyyy, HH:mm");
        }
    }
};
</script>
